import { ETreeRootIds } from 'reactApp/ui/TreeComponent/TreeComponent.constants';

export function getGaFolderType(folder?: { kind?: string; parent?: string; id?: string }): string {
    if (folder?.kind === 'family') {
        return 'family_folder';
    }

    if (folder?.parent !== '/') {
        return 'folder_in_folder';
    }

    if (folder?.id === ETreeRootIds.aiGeneration) {
        return 'ai-generation';
    }

    return 'folder';
}
